import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';
import {
  selectLoans,
  selectLoansPagination,
  selectLoansFilter,
  fetchLoansActions,
  setLoansFilterAction,
  rejectLoansActions,
} from '../ducks';
import { LoanList } from '../components';
import { apiCallIds as loanApiCallIds } from '../api';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { selectToken } from '../../../features/auth/ducks';
import { loanStatus } from '../../../common/enums';

const mapStateToProps = state => ({
  loans: selectLoans(state),
  pagination: selectLoansPagination(state),
  filter: selectLoansFilter(state),
  token: selectToken(state),
  isLoading: selectIsInProgress(state, loanApiCallIds.FETCH_LOANS),
  isRejectingLoans: selectIsInProgress(state, loanApiCallIds.REJECT_LOANS),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAccountLoans: fetchLoansActions.request,
      setFilter: setLoansFilterAction,
      rejectLoans: rejectLoansActions.request,
    },
    dispatch
  ),
});

const defaultFilter = {
  search: '',
  status: loanStatus.POD,
  encashmentStatus: '',
  attribute: '',
};

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class LoanListContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    loans: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isRejectingLoans: PropTypes.bool.isRequired,
    token: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { actions } = this.props;
    actions.setFilter(defaultFilter);
    actions.fetchAccountLoans(defaultFilter);
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.props.pagination.current = pagination.current;
    this.props.actions.fetchAccountLoans({
      ...this.props.filter,
      pageNo: pagination.current - 1,
    });
  };

  onFilterStatusChange = filterValue => {
    const { filter, actions } = this.props;
    actions.setFilter({
      ...filter,
      'status': filterValue,
    });
  };

  onFilterEnchanmentChange = filterValue => {
    const { filter, actions } = this.props;
    actions.setFilter({
      ...filter,
      'encashmentStatus': filterValue,
    });
  };

  onFilterSearchChange = filterValue => {
    const { actions, filter } = this.props;
    actions.setFilter({
      ...filter,
      search: filterValue,
      status: '',
    });
  };

  onFilterLoanAttributeChange = filterValue => {
    const { actions, filter } = this.props;
    actions.setFilter({
      ...filter,
      'attribute': filterValue
    })
  }

  rejectLoans = () => {
    const { filter, actions } = this.props;
    actions.rejectLoans({ ...filter });
  };

  render() {
    const { loans, pagination, filter, isLoading, isRejectingLoans, t, token } = this.props;

    return (
      <div id="loanstablediv">
        <h1>{t('Pôžičky')}</h1>

        <LoanList
          loans={loans}
          pagination={pagination}
          filter={filter}
          onTableChange={this.handleTableChange}
          onFilterSearchChange={this.onFilterSearchChange}
          onFilterStatusChange={this.onFilterStatusChange}
          onFilterEncashmentStatusChange={this.onFilterEnchanmentChange}
          onFilterLoanAttributeChange={this.onFilterLoanAttributeChange}
          isLoading={isLoading}
          isRejectingLoans={isRejectingLoans}
          token={token}
          rejectLoans={this.rejectLoans}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loan-management/containers/LoanListContainer.js